namespace RedBullMOBILE360.CustomerCare {
    export interface UnBlockedSMSCustomersRow {
        Id?: number;
        Msisdn?: string;
        CreationDate?: string;
    }

    export namespace UnBlockedSMSCustomersRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Msisdn';
        export const localTextPrefix = 'CustomerCare.UnBlockedSMSCustomers';
        export const deletePermission = 'CustomerCare:UnBlockedSMSCustomers';
        export const insertPermission = 'CustomerCare:UnBlockedSMSCustomers';
        export const readPermission = 'CustomerCare:UnBlockedSMSCustomers';
        export const updatePermission = 'CustomerCare:UnBlockedSMSCustomers';

        export declare const enum Fields {
            Id = "Id",
            Msisdn = "Msisdn",
            CreationDate = "CreationDate"
        }
    }
}
